import { useState, useEffect } from "react";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';


export default function UsernameCursor({ username }) {
    const [position, setPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const updateMousePosition = (event) => {
            setPosition({ x: event.clientX, y: event.clientY });
        };

        window.addEventListener("mousemove", updateMousePosition);

        return () => {
            window.removeEventListener("mousemove", updateMousePosition);
        };
    }, []);

    // bg-black , bg-primary , bg-dark
    return (
        // <MobileView>
        <BrowserView>
            <div className="relative w-screen h-screen p-0">
                <p
                    className="UsernameCursor absolute bg-primary-75 text-dark mt-0 px-2 py-1 lh-1 "
                    style={{
                        left: `${position.x + 18}px`,
                        top: `${position.y + 18}px`,
                        pointerEvents: "none",
                        position: "fixed",
                    }}
                >
                    {username}
                </p>
            </div>
        </BrowserView>
        // </MobileView>
    );
}